// API Endpoints Configuration
export const API_ENDPOINTS = {
  // 🔐 AUTENTICACIÓN
  AUTH: {
    LOGIN: '/api/auth/login', // ✅ Corregido según respuesta real del backend
    LOGOUT: '/api/auth/logout', // ✅ Corregido
    REFRESH: '/api/auth/refresh', // ✅ Corregido
    REGISTER: '/api/auth/register', // ✅ Corregido
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    VERIFY_TOKEN: '/api/auth/validate', // ✅ Corregido
    VERIFY_2FA: '/api/auth/verify-2fa',
    CHANGE_PASSWORD: '/api/auth/change-password',
    ME: '/api/auth/me', // ✅ Usuario actual
    STATUS: '/api/auth/status', // ✅ Estado de autenticación
  },

  // 📜 MENÚ
  MENU: {
    ACCESS: '/menu/access',
  },
  USERS: {
    BASE: '/api/users', // ✅ Actualizado
    WITH_ROLES: '/api/users/with-roles',
    CHECK_USERNAME: '/api/users/check-username',
    CHECK_EMAIL: '/api/users/check-email',
  },
  PERMISSIONS: {
    BASE: '/api/permissions',
    MY_PERMISSIONS: '/api/permissions/my-permissions',
    USER_PERMISSIONS: '/api/permissions/user',
    CHECK: '/api/permissions/check',
    CACHE: {
      INVALIDATE_USER: '/api/permissions/cache/invalidate',
      INVALIDATE_ALL: '/api/permissions/cache/invalidate-all',
    },
  },

  // 📰 NOTICIAS
  NEWS: {
    BASE: '/api/news',
    BY_ID: '/api/news/{id}',
    PUBLISH: '/api/news/{id}/publish',
    ARCHIVE: '/api/news/{id}/archive',
    MEDIA: '/api/news/{id}/media',
  },

  // 🖼️ IMÁGENES DE NOTICIAS
  NEWS_IMAGES: {
    BASE: '/api/news-images',
    UPLOAD: '/api/news-images/upload',
    BY_ID: '/api/news-images/{id}',
    BY_NEWS: '/api/news-images/by-news/{newsId}',
    DELETE_BY_NEWS: '/api/news-images/by-news/{newsId}',
  },

  // 🎬 VIDEOS DE NOTICIAS
  NEWS_VIDEOS: {
    BASE: '/api/news-videos',
    UPLOAD: '/api/news-videos/upload',
    BY_ID: '/api/news-videos/{id}',
    BY_NEWS: '/api/news-videos/by-news/{newsId}',
    DELETE_BY_NEWS: '/api/news-videos/by-news/{newsId}',
    UPDATE_PRIVACY: '/api/news-videos/{id}/privacy',
    SYNC: '/api/news-videos/{id}/sync',
    SYNC_STATS: '/api/news-videos/{id}/sync-stats',
    SYNC_ALL_STATS: '/api/news-videos/sync-all-stats',
  },

  // 🏷️ MARCAS
  BRANDS: {
    BASE: '/api/brands',
    BY_ID: '/api/brands/{id}',
    ACTIVE: '/api/brands/active',
  },

  // 📂 CATEGORÍAS
  CATEGORIES: {
    BASE: '/api/categories',
    BY_ID: '/api/categories/{id}',
    ACTIVE: '/api/categories/active',
  },

  // 🎬 VIDEOS
  VIDEOS: {
    BASE: '/api/videos',
    BY_ID: '/api/videos/{id}',
    UPLOAD: '/api/videos/upload',
    DELETE: '/api/videos/{id}',
  },

  // ===== CHANNEL VIDEOS ENDPOINTS =====
  CHANNEL_VIDEOS: {
    BASE: '/api/channel-videos',

    // Sincronización
    SYNC: '/api/channel-videos/sync',
    SYNC_DEFAULT: '/api/channel-videos/sync/default',
    SYNC_VIDEO: '/api/channel-videos/sync/{youtubeVideoId}',
    SYNC_STATS: '/api/channel-videos/sync/stats',

    // Consultas públicas
    PUBLIC: '/api/channel-videos/public',
    SEARCH: '/api/channel-videos/search',
    POPULAR: '/api/channel-videos/popular',
    RECENT: '/api/channel-videos/recent',

    // Consultas por ID
    BY_ID: '/api/channel-videos/{id}',
    BY_YOUTUBE_ID: '/api/channel-videos/youtube/{youtubeVideoId}',
    BY_CHANNEL: '/api/channel-videos/channel/{channelId}',

    // Consultas admin
    ALL: '/api/channel-videos',
    DATE_RANGE: '/api/channel-videos/date-range',

    // Estadísticas
    STATISTICS: '/api/channel-videos/statistics',
    VIDEO_STATISTICS: '/api/channel-videos/{youtubeVideoId}/statistics',

    // Gestión
    DELETE_BY_ID: '/api/channel-videos/{id}',
    DELETE_BY_YOUTUBE_ID: '/api/channel-videos/youtube/{youtubeVideoId}',
    UPDATE_SYNC_STATUS: '/api/channel-videos/{id}/sync-status',
  },

  // ===== SYNCHRONIZE ENDPOINTS (ACTUALIZADOS) =====
  SYNCHRONIZE: {
    STATUS: '/api/channel-videos/sync/status', // ← Actualizado
    START: '/api/channel-videos/sync/default', // ← Actualizado
    STOP: '/api/channel-videos/sync/stop', // ← Actualizado
    CUSTOM: '/api/channel-videos/sync', // ← Actualizado
    STATS: '/api/channel-videos/sync/stats', // ← Actualizado
  },
} as const;

// Tipos para ayudar con el autocompletado
export type AuthEndpoints = typeof API_ENDPOINTS.AUTH;
export type MenuEndpoints = typeof API_ENDPOINTS.MENU;
